export interface ViewPreference {
  showEfficiency: boolean;
  showSlidingVelocity: boolean;
  showSpeed100VolumetricEfficiency: boolean;
  showTolerances: boolean;
  showNpshrLow: boolean;
  useImperialUnits: boolean;
}
